import type { Account } from "@nwt/norce-pwa/dist/runtime/types/api/account/account";
import { defineStore, acceptHMRUpdate } from "pinia";

interface State {
	user: Account | null;
}

export const userStore = defineStore({
	id: "userStore",
	state: (): State => ({
		user: null
	}),
	actions: {
		async setUser(value: Account | null) {
			const previous = this.user;
			if (value) {
				// SSN is never used by the storefront — drop it so it is not kept
				// in client state / persisted to localStorage.
				delete value.SSN;
			}
			this.user = value;
			const selectedCompany = useSelectedCompanyStore();
			if (value) {
				// Keep selected-company store consistent with the latest user payload.
				selectedCompany.syncWithUser(value);
			} else if (previous) {
				// Explicit logout (transition from logged-in to null) — drop the company
				// selection and any company/user-derived pricelistSeed left in
				// localStorage. We deliberately skip this for the null→null hydration
				// path so the persisted state survives page reloads.
				selectedCompany.reset();
				const norceStore = useNorceStore();
				norceStore.setSalesAreaId(undefined);
			}
			await useWishlistStore().updateWishlistOnLogIn();
		}
	},
	getters: {
		getUser: (state) => state.user
	},
	persist: [{ storage: persistedState.localStorage, pick: ["user"] }]
});
if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(userStore, import.meta.hot));
}
